import './index.scss'

class OCEVideo {
    constructor(el) {
        this.$el = el

        // console.log('Video::constructor')
    }
    init() {
        this.$poster = this.$el.querySelector('.oce-video__poster')
        this.$iframe = this.$el.querySelector('iframe')

        const controlVideo = (control, id) => {
            var iframe = id.contentWindow;
            iframe.postMessage(
              '{"event":"command","func":"'+ control +'","args":""}',
              "*"
            );
        }
        
        this.$poster.addEventListener('click', () => {
            controlVideo('playVideo', this.$iframe)
            this.$poster.style.opacity = '0'
            this.$poster.style.pointerEvents = 'none'
        }, {capture: true, passive: true, once: true} || true)
        
    }
}

document.addEventListener('DOMContentLoaded', () => {
    [ ...document.querySelectorAll('.oce-video') ].forEach($block => {
        $block.expandygg = new OCEVideo($block)
    })
}, {capture: false, passive: true, once: true} || false)